export default "__VITE_ASSET__BPfFqDU0__"